import React from 'react';

const Paginator = ({ currentPage, totalPages, onPageChange }) => {
  const handlePrevClick = () => {
    if (currentPage > 1) {
      onPageChange(currentPage - 1);
    }
  };

  const handleNextClick = () => {
    if (currentPage < totalPages) {
      onPageChange(currentPage + 1);
    }
  };

  return (
    <div className="paginator">
      <button 
        className={`paginator-button ${currentPage === 1 ? 'disabled' : ''}`} 
        onClick={handlePrevClick}
        disabled={currentPage === 1}
      >
        <i class="fa-solid fa-chevron-left"></i>
      </button>
      <div className="paginator-page">
        {currentPage}
      </div>
      <button 
        className={`paginator-button ${currentPage === totalPages ? 'disabled' : ''}`} 
        onClick={handleNextClick}
        disabled={currentPage === totalPages}
      >
        <i class="fa-solid fa-chevron-right"></i>
      </button>
      <div className="paginator-total">
        de {totalPages}
      </div>
    </div>
  );
};

export default Paginator;